import { DiffView, GridFormFlexItemWrapper } from "@bagel-web/components";
import { CommonKVMessage } from "../../types";
import {
  EditMessageComponent,
  EditMessageComponentProps,
  EventBody,
  MessageComponent,
  MessageComponentProps,
} from "./Message";
import { Form } from "react-bootstrap";

const KVMessage: MessageComponent<CommonKVMessage> = ({
  message,
  relatedMessages,
  displaySettings,
}: MessageComponentProps<CommonKVMessage>) => {
  return (
    <>
      <h6>
        <code>{message.key}</code>
      </h6>
      {displaySettings?.showFactDiffs && relatedMessages?.[0] ? (
        <DiffView
          oldValue={relatedMessages[0]?.value || message.value}
          newValue={message.value}
          showDiffOnly={
            displaySettings.hideUnchagedFactLines &&
            relatedMessages[0]?.value !== message.value
          }
        />
      ) : (
        <p
          style={{
            fontFamily: "monospace",
            fontSize: ".875em",
          }}
        >
          {message.value}
        </p>
      )}
    </>
  );
};

export const EditKVMessage: EditMessageComponent<CommonKVMessage> = ({
  message,
  onGameEventMessageChange,
}: EditMessageComponentProps<CommonKVMessage>) => {
  return (
    <>
      <GridFormFlexItemWrapper>
        <Form.Label className="mb-3">Key</Form.Label>
        <EventBody style={{ flexGrow: 1 }}>
          <Form.Control
            required
            value={message.key}
            onChange={(e) =>
              onGameEventMessageChange({
                ...message,
                key: e.target.value,
              })
            }
          />
        </EventBody>
      </GridFormFlexItemWrapper>
      <EventBody>
        <Form.Control
          style={{ height: "100px" }}
          as="textarea"
          value={message.value}
          onChange={(e) =>
            onGameEventMessageChange({
              ...message,
              value: e.target.value,
            })
          }
        />
      </EventBody>
    </>
  );
};

export default KVMessage;
